export default __webpack_public_path__ + "static/media/e-commerce1 (1).cb5e83d7.gif";